<template>
  <main class="page-companies-create py-5">
    <div class="container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-10 col-lg-10 mx-auto">
            <AwlCard title="Aggiungi azienda" border box-shadow>
              <AddCompanyForm :consultants="consultants" @submit="onSubmit" />
            </AwlCard>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  components: {
    AwlCard: () => import('@/views/components/Layout/Card/AwlCard.vue'),
    AddCompanyForm: () => import('@/views/components/Form/AddCompanyForm.vue'),
  },
  data () {
    return {
      company: {},
      consultants: [],
    };
  },
  methods: {
    onSubmit () {
      this.$router.push({ name: 'companies-index' });
    },
  },
  mounted () {
    if (this.$oauth2?.me?.admin) {
      this.$api.consultants()
        .then(res => {
          this.consultants = res.data?.consultants || [];
        })
        .catch(() => this.$log.error)
      ;
    }
  },
};

</script>
